<template>
  <v-card class="item" v-hover="'grey lighten-4'" rounded="xl" flat>
    <img
      class="d-block item-img"
      :src="files + img + '?resize=1&w=600'"
      :alt="title"
      width="100%"
    />

    <div class="pa-3 pa-md-4 item-caption">
      <div class="text-h6 text-center item-title">
        {{ title }}
      </div>

      <div v-if="subtitle" class="text-body-1 font-weight-light pt-3">
        {{ subtitle }}
      </div>

      <div v-if="links.length" class="d-flex justify-center flex-wrap pt-4">
        <v-btn
          class="mx-1"
          :href="link"
          :target="target"
          v-for="({ link, target, color, icon, iconSize }, keyLinks) in links"
          :key="keyLinks"
          :color="color"
          height="32px"
          width="32px"
          small
          depressed
          fab
        >
          <v-icon color="white" :size="iconSize"> {{ icon }} </v-icon>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    whatsapp: {
      type: String,
      default: "",
    },
    facebook: {
      type: String,
      default: "",
    },
    instagram: {
      type: String,
      default: "",
    },
    linkedin: {
      type: String,
      default: "",
    },
  },
  computed: {
    links() {
      const links = [];

      if (this.email)
        links.push({
          link: `mailto:${this.email}`,
          target: "_self",
          color: "#617379",
          icon: "far fa-envelope",
          iconSize: 16,
        });

      if (this.whatsapp)
        links.push({
          link: getWhatsappLinkFromPhone(this.whatsapp),
          target: "_blank",
          color: "#25d366",
          icon: "fab fa-whatsapp",
          iconSize: 20,
        });

      if (this.facebook)
        links.push({
          link: this.facebook,
          target: "_blank",
          color: "#3a5998",
          icon: "fab fa-facebook-f",
          iconSize: 16,
        });

      if (this.instagram)
        links.push({
          link: this.instagram,
          target: "_blank",
          color: "#d6249f",
          icon: "fab fa-instagram",
          iconSize: 18,
        });

      if (this.linkedin)
        links.push({
          link: this.linkedin,
          target: "_blank",
          color: "#2867b2",
          icon: "fab fa-linkedin",
          iconSize: 16,
        });

      return links;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 4 / 3;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
